import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=99089b32"
import script from "./contact.ts?vue&type=script&lang=js&external"
export * from "./contact.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports